<template>
	<layout-admin-auto-loading class="admin-user-list" :loader="getUsers" :loading="loading" :finished="finished" :error="error">
		<h1 slot="header">(Admin) User List</h1>
		<div slot="body" v-if="!error">
			<!--div v-if="data.length" class="idi-table users">
				<div class="idi-header">
					<div class="idi-cell">ID</div>
					<div class="idi-cell">UID</div>
					<div class="idi-cell">Full Name</div>
					<div class="idi-cell">Email</div>
					<div class="idi-cell">Activation Time</div>
				</div>
				<div class="idi-row" v-for="user in data" :key="user.id">
					<div class="idi-cell grid-area-id">
						<span>{{ user.id }}</span>
					</div>
					<div class="idi-cell grid-area-uid">
						<span><router-link :to="{ name: 'WatchList', params: { user_uid: user.uid } }">{{ user.uid }}</router-link></span>
					</div>
					<div class="idi-cell grid-area-fullname">
						<span>{{ user.fullname }}</span>
					</div>
					<div class="idi-cell grid-area-email">
						<span><a :href="`mailto:${user.email}`">{{ user.email }}</a></span>
					</div>
					<div class="idi-cell grid-area-activation">
						<span>{{ datetime(user.activation_time) }}</span>
					</div>
				</div>
			</div>
			<p v-if="finished && !data.length">No Users found.</p-->
			<admin-data-table :finished="finished" :table_columns="table_columns" :table_rows="table_rows"/>
		</div>
	</layout-admin-auto-loading>
</template>

<script>
import LayoutAdminAutoLoading from '../LayoutAdminAutoLoading'
import AdminDataTable from '../AdminDataTable'
export default {
	components: {
		LayoutAdminAutoLoading,
		AdminDataTable
	},
	data () {
		return {
			loading: false,
			error: null,
			data: [],
			finished: false,
			limit: 20,
			table_columns: [
				{
					label: '#',
					field: 'id',
					width: '75px'
				},
				{
					label: 'UID',
					field: 'uid'
				},
				{
					label: 'Name',
					field: 'name',
				},
				{
					label: 'Email',
					field: 'email',
				},
				{
					label: 'Activation Time',
					field: 'activation_time'
				}
			]
		}
	},
	computed: {
		offset () {
			return this.data.length
		},
		table_rows () {
			return this.data.map(row => {
				return {
					columns: [
						{ field: 'id', value: row.id },
						{ field: 'uid', value: { title: row.uid, to: { name: 'WatchList', params: { user_uid: row.uid } } }, type: 'link' },
						{ field: 'name', value: row.fullname },
						{ field: 'email', value: row.email, type: 'email' },
						{ field: 'activation_time', value: this.$moment(row.activation_time).format('YYYY-MM-DD HH:mm:ss') },
					]
				}
			})
		}
	},
	methods: {
		datetime (date) {
			return this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
		},
		getUsers () {
			this.loading = true
			this.$api.users.admin.getAll(this, this.offset, this.limit).then(response => {
				this.$log.info('admin', 'users.admin.getAll OK', response)()
				if (response.body.length) {
					this.data = this.data.concat(response.body)
				}
				if (!response.body.length || response.body.length < this.limit) {
					this.finished = true
				}
			}).catch(errors => {
				this.$log.error('admin', 'users.admin.getAll ERROR', errors)()
				this.error = errors
			}).finally(() => {
				this.loading = false
			})
		}
	},
	beforeCreate () {
		this.$title('User List')
	}
}
</script>



// WEBPACK FOOTER //
// src/components/admin/users/UserList.vue